import { apiService } from './api';
import { DashboardStats, RecentExecution } from '../types/api.types';

export const dashboardService = {
  getDashboardStats: async (): Promise<DashboardStats> => {
    const [stats, recentExecutions] = await Promise.all([
      apiService.get<{
        totalWorkflows: number;
        activeExecutions: number;
        successRate: number;
        avgExecutionTime: string;
      }>('/workflows/stats/'),
      apiService.get<RecentExecution[]>('/executions/recent/', {
        limit: 10,
      }),
    ]);

    return {
      ...stats,
      recentExecutions: recentExecutions.map((exec: any) => ({
        id: exec.id,
        workflowName: exec.workflow_name || exec.workflow?.name || 'Unknown',
        status: exec.status,
        startedAt: exec.started_at,
        duration: exec.duration ? formatDuration(exec.duration) : undefined,
      })),
    };
  },
};

function formatDuration(duration: string | number): string {
  if (typeof duration === 'number') {
    if (duration < 60) {
      return `${duration.toFixed(1)}s`;
    } else if (duration < 3600) {
      return `${(duration / 60).toFixed(1)}m`;
    } else {
      return `${(duration / 3600).toFixed(1)}h`;
    }
  }
  
  // If it's already a string (like "1.2s"), return as is
  return duration.toString();
}

















